// components/DeliveryScheduleBadge.js
// The one place the dashboard says whether an order goes out now or in a
// customer-chosen window. Wording comes from utilities/deliverySchedule.js and
// the pill from OrderStatusBadges, so every order page reads the same.

import React from "react";
import { StatusBadge } from "./OrderStatusBadges";
import { describeDeliverySchedule } from "../utilities/deliverySchedule";

const EXPRESS_CFG = { bg: "#eef7e1", color: "#4f7a12", border: "#d5eab5", icon: "fa-bolt" };
const SCHEDULED_CFG = { bg: "#e6f0fb", color: "#0b4f8a", border: "#c7dcf3", icon: "fa-calendar-alt" };

const DeliveryScheduleBadge = ({ order, style }) => {
  const { scheduled, label, timeZone } = describeDeliverySchedule(order);
  return (
    <StatusBadge
      label={label}
      cfg={scheduled ? SCHEDULED_CFG : EXPRESS_CFG}
      title={scheduled ? `Deliver within this window (${timeZone} time)` : "Deliver as soon as possible"}
      style={style}
    />
  );
};

export default DeliveryScheduleBadge;
